/* 🤖 this file was generated by script */
export const wiconRefreshCw01 = {
  name: 'refresh_cw_01',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 10s-2-2.73-3.63-4.36a9 9 0 102.28 8.86M21 10V4m0 6h-6"/></svg>`,
};
